module.exports = __webpack_public_path__ + "img/Icon ionic-ios-settings.4a0fd710.svg";